<script>
    export default {

        data: function () {

            return {
                active: false,
                active_done: false,
                clients: [],
                client: null,
                dataFrm: null,
                confirmInfo: null,
                slug: null,
                loading: false,
            }

        },

        mounted: function () {

            var vm = this;

            this.$event_bus.$on('LoadEventData', (data) => {
                this.slug = data.event.slug;
            });

            this.$event_bus.$on('chooseEventUser', (data) => {
                this.active = true;
                if ($(window).width() < 500) {
                    setTimeout(function(){
                        $('html, body').animate({scrollTop:$('#information-panel-event').offset().top});
                    }, 250);
                };
                this.clients = data.clients;
                this.dataFrm = data.dataFrm;
                this.confirmInfo = data.confirmInfo;

                this.$nextTick(function () {
                    $('#collapseEventClients').collapse('show');
                });
            });

            this.$event_bus.$on('event-restart', () => {
                this.active = false;
                this.active_done = false;
            });

            this.$event_bus.$on('FillEventInfoShowed', () => {
                this.active = false;
                this.active_done = false;
            });

            $('#collapseEventClients').on('show.bs.collapse', function () {
                vm.$event_bus.$emit('EventClientsShowed');
            });

        },

        methods: {
            clientClicked(client) {
                this.active_done = true;
                this.loading = true;

                this.client = client;
                if (client.id == 'new') {
                    this.client.name = this.logged_in_client ? this.logged_in_client.name : this.confirmInfo.name;
                }

                this.dataFrm.append('client', client.id);
                this.$event_bus.$emit('confirmEvent', {dataFrm: this.dataFrm, confirmInfo: this.confirmInfo});
            }
        },
    };


</script>


<template>

    <div class="panel" id="choose-event-user" v-if="active">

        <a class="panel-title" data-toggle="collapse" href="#collapseEventClients" role="button" aria-expanded="false" aria-controls="collapseEventClients" :class="{'disable-link' : active, 'enable-link' : active_done }" @click="active_done = false">
            <div class="panel-heading-small" :class="{ 'bg-green' : active, 'bg-green-done' : active_done }" role="tab" id="headingClients">
                <i class="zmdi zmdi-accounts m-r-5"></i>
                <span v-if="!client">{{ trans('events.choose_who') }}</span>
                <span v-if="client">{{ client.name }}</span>
            </div>
        </a>

        <div id="collapseEventClients" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingClients" data-parent="#event-accordion">

            <div class="panel-body" id="choose-user-body-booking">

                <div class="row">

                    <div class="col-xs-12">

                        <ep-banner class="mb-6">
                            <i class="zmdi zmdi-info-outline m-r-10 alert-ico"></i>
                            <span class="m-b-5">{{ trans('online_payment.choose_client_1') }}</span><br>
                            <strong class="alert-indent">{{ trans('events.choose_who_2') }}</strong>
                        </ep-banner>

                        <div class="row">

                            <div class="col-sm-6 col-lg-4 m-b-15" v-for="client in clients">
                                <a class="btn btn-default btn-block" @click="clientClicked(client)">
                                    <i class="zmdi zmdi-account m-r-10 alert-ico"></i>{{ client.name }}
                                </a>
                            </div>
                            <div class="col-sm-6 col-lg-4 m-b-15">
                                <a class="btn btn-primary btn-block" @click="clientClicked({id: 'new'})">
                                    <i class="zmdi zmdi-account-add m-r-10 alert-ico"></i>
                                    {{ trans('online_payment.as_new_client') }}
                                </a>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
